import React, { useContext, useMemo } from "react";
import { Route, Redirect } from "react-router-dom";
import AppContext from "../context/Context";
import Loader from "../components/common/Loader";
import { CloseButton, ToastContainer } from "react-bootstrap";
import { Fade } from "reactstrap";
import { toast } from "react-toastify";
import ErrorLayout from "../layouts/ErrorLayout";
import { setItemToStore } from "../helpers/utils";

function AdminPrivateRoute({ component: Component, path, ...rest }) {
  let pathSplit = path.split("/");
  // let roles = ["liUpdateDetailsButton", "liApplicationIDLabel", "liLogInAccessGridButtonAllowRevoke"]; //user_not_access_list
  let rolesPerComponent = [
    {
      name: "partner-details",
      handlers: [
        "liUpdateDetailsButton",
        "liDeletePartnerButton",
        "liAddApplicationButton",
        "liUpdateApplicationButton",
        "liDeleteApplicationButton",
        "liApiAccessButton",
        "liApiAccessGridButton",
        "liCheckDataAvailableGridButton",
        "liDeletePartnerCustomerButton",
        "liAddTeamMemberButton",
        "liLogInAccessGridButtonAllowRevoke",
        "liAccessTypeGridButtonFullReadOnly",
        "liApplicationIDLabel",
        "liApplicationKeyTable",
        "liAddDemoPracticeButton",
        "liTransferCustomerButton",
        "liAddCustomerButton",
        "liSpuCountByPmsGraph",
        "liUpdatePracticeLocationAccess",
        "liPartnerDetailsComponent",
        "liApplicationDetailsComponent",
        "liApiAccessListComponent",
        "liPartnerCustomerListComponent",
        "liAPIAccessOnOffLineChartComponent",
        "liTeamMemberListComponent",
        "liUpdateUserEmailGridButton",
        "liUserSetAsSuperAdminButton",
        "liApisRequireConsentFromPartners",
        "liApplicationSecretKeyRefreshButton",
        "liPieChartForPartnerComponent",
        "liDownlaodCsvSelectedLocationsButton",
        "liPartnerSLAPlanUpdateButton",
        "liPartnerStatusUpdateButton",
        "liPartnerIsVerifiedUpdateButton",
        "liApplicationStatusUpdateButton",
        "liApplicationSLAPlanUpdateButton",
        // "liFreshDeskPartnerTicketsStatsComponent",
        "liPendingDeleteApplicationButton",
        "liMarketplaceStatusUpdateButton",
        "liTeamMemberGenerateLink",
        "liPauseResume"
      ],
    },
    {
      name: "webhook",
      handlers: ["liAddWebhookButton", "liEditWebhookButton", "liDeleteWebhookButton", "liDetailsWebhookButton"],
    },
    {
      name: "api-explorer",
      handlers: ["liApiTestingToolPartnerDropdown"],
    },
    {
      name: "billing",
      handlers: [
        "liPartnerDropDownControl",
        "liApplicationDropDownControl",
        "liEditOrAddApplicationButton",
        "liYearSelectionDropDown",
        "liMonthSelectionDropDown",
        "liBillingInformationComponent",
        "liSeatConfigurationComponent",
        "liPaymentAddCardComponent",
        "liContractBillingComponent",
        "liChargeButtonPartnerBillingDeatils",
        "liPartnerBillingReportComponent",
        "liQuickBookInvoicesComponent",
        "liQuickBookConnectComponentButton"
      ],
    },
    {
      name: "users",
      handlers: ["liAddAdminSettingsUsers", "liLoginAccessSettingsUsers", "liUpdateRoleNameSettingsUsers","liInviteSikkaAdminLink"],
    },
    {
      name: "roles",
      handlers: ["liAddRoleSettingsRoles", "liEditRoleSettingsRoles"],
    },
    {
      name: "table-editor",
      handlers: [
        "liAddNewRecordSettingsTableEditor",
        "liTableSelectDropDownSettingsTableEditor",
        "liEditButtonSettingsTableEditor",
      ],
    },
    {
      name: "api-tiers",
      handlers: [
        "liAddNewPlanButtonSettingsApiTiers",
        "liDeletePlanButtonSettingsApiTiers",
        "liUpdatePlanGridButtonApiTiers",
      ],
    },
    {
      name: "api-plan",
      handlers: ["liApiPlanSaveButton"],
    },
    {
      name: "writeback",
      handlers: [
        "liWritebackFromDateSelectorBtn",
        "liWritebackToDateSelectorBtn",
        "liWritebackSubmitDateBtn",
        "liWritebackPendingResultDeleteBtn",
      ],
    },
    // {
    //   name: "freshdesk",
    //   handlers: ["liFreshdeskCompaniesButton"],
    // },
  ];

  const { loginUserDetails, accessToken } = useContext(AppContext);

  const allowedActions = (componentName) => {
    let selectedRole = rolesPerComponent.find((roles) => {
      return roles.name === componentName;
    });
    if (selectedRole) {
      selectedRole.handlers = selectedRole?.handlers.filter((handler) => {
        return !loginUserDetails.user_not_acccess_list.includes(handler);
      });
    }
    return selectedRole;
  };

 useMemo(()=>{
  if (JSON.parse(localStorage.getItem("isLoggedIn"))) {
    
    setItemToStore("lastPath",window.location.pathname.replace("/v4/portal/",""))
  }
 },[window.location.href])

  return (
    Object.keys(loginUserDetails).length > 0 && (
      <Route
      {...rest}
      render={(props) =>
        // loginUserDetails?.token && loginUserDetails?.is_partner === "0" ? (
        localStorage.getItem("isLoggedIn") === "true" &&
        loginUserDetails &&
        Object.keys(loginUserDetails).length > 0 &&
        loginUserDetails.is_partner === "0" ? (
          //localStorage.getItem('actn')?(
          <Component {...props} actions={allowedActions(pathSplit[pathSplit.length - 1])} />
        ) : (
          <>
          <Route component={ErrorLayout} />
          <ToastContainer transition={Fade} closeButton={<CloseButton />} position={toast.POSITION.BOTTOM_LEFT} />
          </>
        )
      }
    />)
  );
}

export default AdminPrivateRoute;
